export default __webpack_public_path__ + "static/media/sideMenu_timeline.a80eebb3.svg";